export function formatPhoneNumber(phoneNumber: string): string {
  // Remove all non-digit characters except '+'
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');

  // Check if it starts with a '+' for E.164 format
  if (cleaned.startsWith('+')) {
    const digitsOnly = cleaned.slice(1).replace(/\D/g, '');
    if (digitsOnly.length >= 10 && digitsOnly.length <= 15) {
      return formatE164WithCountryCode(cleaned);
    }
    return phoneNumber;
  }

  // Check if it starts with '1' without '+'
  if (cleaned.startsWith('1')) {
    const digitsOnly = cleaned.replace(/\D/g, '');
    if (digitsOnly.length === 11) {
      return formatE164WithCountryCode(`+${digitsOnly}`);
    }
    if (digitsOnly.length === 10) {
      return formatLocal(digitsOnly);
    }
    return phoneNumber;
  }

  // Check if it is just 10 digits
  const digitsOnly = cleaned.replace(/\D/g, '');
  if (digitsOnly.length === 10) {
    return formatLocal(digitsOnly);
  }

  // If none of the conditions are met, return the original string
  return phoneNumber;
}

function formatE164WithCountryCode(phoneNumber: string): string {
  // Assumes phoneNumber is in proper E.164 format
  const countryCode = phoneNumber.slice(1, phoneNumber.length - 10);
  const mainNumber = phoneNumber.slice(phoneNumber.length - 10);
  const areaCode = mainNumber.slice(0, 3);
  const centralOffice = mainNumber.slice(3, 6);
  const lineNumber = mainNumber.slice(6);

  if (countryCode === '1') {
    return `(${areaCode}) ${centralOffice}-${lineNumber}`;
  } 
    return `+${countryCode} (${areaCode}) ${centralOffice}-${lineNumber}`;
  
}

function formatLocal(digitsOnly: string): string {
  const areaCode = digitsOnly.slice(0, 3);
  const centralOffice = digitsOnly.slice(3, 6);
  const lineNumber = digitsOnly.slice(6);

  return `(${areaCode}) ${centralOffice}-${lineNumber}`;
}
